// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iO0d","toggleWrap":"styles_toggleWrap__2Cbep","content":"styles_content__WObXg","selectAreaCode":"styles_selectAreaCode__UGCax"};